export default class Menu extends Phaser.State {

  preload() {
  }

  create() {

    this.state.start('Game');

  }

}
